import React, { Component } from "react";

import IlomeModalView from "./IlomeModalView";
import createApiService from "../../../../network";
import axios from "axios";
import { normalize } from "normalizr";
import { ceremony as ceremonySchema } from "../../../../schemas";
import i18n from "../../../../constants/i18n";

class IlomeModalContainer extends Component {
    constructor(props) {
        super(props);

        this.api = createApiService(axios);
    }

    async onSuccesfullUpdate() {
        const {
            data: { data: ceremony },
        } = await this.api.getCeremonyById(this.props.ceremonyId);
        const { entities } = normalize(ceremony, ceremonySchema);

        this.props.updateStoreEntities(entities);
        this.props.hideModal();

        this.props.showToast({
            body: i18n.ilomeModal.updateSuccess,
            title: "Success",
            themeClass: "is-success",
        });
    }

    render() {
        return (
            <IlomeModalView
                isVisible={true}
                hideModal={this.props.hideModal}
                ceremonyId={this.props.ceremonyId}
                ilomeName={this.props.ceremony.ilomeName}
                ilomeEmail={this.props.ceremony.ilomeEmail}
                onSuccesfullUpdate={this.onSuccesfullUpdate.bind(this)}
            />
        );
    }
}

export default IlomeModalContainer;
